var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"copy",rawName:"v-copy",value:(_vm.content),expression:"content"}],staticClass:"copy-icon gj-cell-display-switch"},[(_vm.isMeaningful(_vm.content))?_c('gj-icon',{staticClass:"el-icon-copy-document"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }